import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useQuery from 'hooks/useQuery';
import QueryKeys from './keys';
import { SMS } from 'domains/content/types';

const useSms = (smsId: string, reactQueryOptions?: UseQueryOptions<SMS, Error>) =>
    useQuery<SMS>(QueryKeys.SMS_ID(smsId), new PathWithID(CuredApiPaths.SMS, Number(smsId)).url, reactQueryOptions);

export default useSms;
